module.exports = __webpack_public_path__ + "img/change.69c2dff8.svg";